import { render } from "./ScreenWelcome.vue?vue&type=template&id=ca9d54b4&scoped=true"
import script from "./ScreenWelcome.vue?vue&type=script&lang=js"
export * from "./ScreenWelcome.vue?vue&type=script&lang=js"

import "./ScreenWelcome.vue?vue&type=style&index=0&id=ca9d54b4&scoped=true&lang=css"

import exportComponent from "/Users/bruno/Documents/Codex/bam4-share-link-work/bam4-master/client/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca9d54b4"]])

export default __exports__